module.exports = __webpack_public_path__ + "static/media/order-service-preview.f93f13a5.png";